export interface FilterField {
  key: string;
  label: string;
}

export const TEXT_FILTER_FIELDS: FilterField[] = [
  { label: "CVF Ref",       key: "CVFRef" },
  { label: "Cliente",       key: "Client" },
  { label: "Exportador",    key: "Exporter" },
  { label: "Status",        key: "Status" },
  { label: "Responsável",   key: "Responsible" },
  { label: "Incoterm",      key: "Incoterm" },
  { label: "Canal",         key: "Channel" },
  { label: "DI",            key: "Di" },
  { label: "LI",            key: "Li" },
  { label: "BL/AWB",        key: "blAwb" },
  { label: "Nº Container",  key: "ContainerNumber" },
  { label: "NCM",           key: "Ncm" },
  { label: "Número Ref.",             key: "ClientRef" },
  { label: "Aparece pro cliente",     key: "RefName" },
  { label: "Despachante",             key: "Dispatcher" },
  { label: "Modo de Importação",      key: "ImportMode" },
  { label: "Total Invoice",           key: "TotalInvoice" },
  { label: "Frete internacional",     key: "InternationalFreight" },
  { label: "CE Mercante",             key: "CeMerchant" },
  { label: "Forma de pagamento",      key: "PaymentCondition" },
  { label: "Número da invoice",       key: "Invoice" },
  { label: "Qtde. de Containers",     key: "ContainerQuantity" },
  { label: "Embarcação",              key: "Vessel" },
  { label: "Agente de Cargas",        key: "Carrier" },
  { label: "Local de Origem",         key: "CountryOfOrigin" },
  { label: "Local de Destino",        key: "DischargePort" },
  { label: "Armador",                 key: "CustomsAgent" },
  { label: "Demurrage",               key: "Demurrage" },
  { label: "Situação dos Câmbioss",   key: "PaymentStatus" },
  { label: "Moeda invoice",           key: "Currency" },
  { label: "Free Time",               key: "FreeTime" },
  { label: "Cotação Internacional",   key: "InternationalQuote" },
  { label: "Cotação Rodoviária",      key: "RoadQuote" },
  { label: "Seguro",                  key: "Insurance" },
  { label: "ICMS",                    key: "Icms" },
  { label: "Numerário",               key: "CashAmount" },
  { label: "Documentos",              key: "Documents" },
  { label: "Catálogo PU",             key: "CatalogPu" },
  { label: "Status LI",               key: "LiStatus" },
  { label: "Segmento",                key: "Segment" },
  { label: "Taxa Câmbio 1",           key: "TaxaCambio1" },
  { label: "Taxa Câmbio 2",           key: "TaxaCambio2" },
  { label: "Taxa Câmbio 3",           key: "TaxaCambio3" },
  { label: "Valor Parcela 1",         key: "ValorPagamento1" },
  { label: "Valor Parcela 2",         key: "ValorPagamento2" },
  { label: "Valor Parcela 3",         key: "ValorPagamento3" },
  { label: "Contrato 1º Pagamento",   key: "ContratoCambio1" },
  { label: "Contrato 2º pagamento",   key: "ContratoCambio2" },
];

export const DATE_FILTER_FIELDS: FilterField[] = [
  { key: "OpeningDate",          label: "Data Abertura" },
  { key: "ShippingDate",         label: "Data Embarque" },
  { key: "ArrivalDate",          label: "Data Chegada" },
  { key: "RegistrationDate",     label: "Data Registro" },
  { key: "CustomsClearanceDate", label: "Data do Desembaraço" },
  { key: "NfIssued",             label: "Data Emissão da NF" },
  { key: "DataCambio1",          label: "Data Câmbio 1" },
  { key: "DataCambio2",          label: "Data Câmbio 2" },
  { key: "DataCambio3",          label: "Data Câmbio 3" },
  { key: "DataPagamento1",       label: "Data Pagamento 1" },
  { key: "DataPagamento2",       label: "Data Pagamento 2" },
  { key: "DataPagamento3",       label: "Data Pagamento 3" },
];

export type FilterKind = "text" | "date" | "client" | "status" | "channel" | "responsible";

export interface ColumnFilter {
  kind: FilterKind;
  key: string;
}

// label da coluna (ALL_FIELDS) -> filtro correspondente
export const COLUMN_FILTERS: Record<string, ColumnFilter> = {
  "CVF Ref":             { kind: "text",    key: "CVFRef" },
  "Cliente":             { kind: "client",  key: "Client" },
  "Exportador":          { kind: "text",    key: "Exporter" },
  "Status":              { kind: "status",  key: "Status" },
  "Responsável":         { kind: "responsible", key: "Responsible" },
  "Incoterm":            { kind: "text",    key: "Incoterm" },
  "Canal":               { kind: "channel", key: "Channel" },
  "DI":                  { kind: "text",    key: "Di" },
  "LI":                  { kind: "text",    key: "Li" },
  "BL/AWB":              { kind: "text",    key: "blAwb" },
  "Nº Container":        { kind: "text",    key: "ContainerNumber" },
  "NCM":                 { kind: "text",    key: "Ncm" },
  "Data Abertura":       { kind: "date",    key: "OpeningDate" },
  "Data Embarque":       { kind: "date",    key: "ShippingDate" },
  "Data Chegada":        { kind: "date",    key: "ArrivalDate" },
  "Data Registro":       { kind: "date",    key: "RegistrationDate" },
  "Data do Desembaraço": { kind: "date",    key: "CustomsClearanceDate" },
  "Data Emissão da NF":  { kind: "date",    key: "NfIssued" },

  "Número Ref.":             { kind: "text", key: "ClientRef" },
  "Aparece pro cliente":     { kind: "text", key: "RefName" },
  "Despachante":             { kind: "text", key: "Dispatcher" },
  "Modo de Importação":      { kind: "text", key: "ImportMode" },
  "Total Invoice":           { kind: "text", key: "TotalInvoice" },
  "Frete internacional":     { kind: "text", key: "InternationalFreight" },
  "CE Mercante":             { kind: "text", key: "CeMerchant" },
  "Forma de pagamento":      { kind: "text", key: "PaymentCondition" },
  "Número da invoice":       { kind: "text", key: "Invoice" },
  "Qtde. de Containers":     { kind: "text", key: "ContainerQuantity" },
  "Embarcação":              { kind: "text", key: "Vessel" },
  "Agente de Cargas":        { kind: "text", key: "Carrier" },
  "Local de Origem":         { kind: "text", key: "CountryOfOrigin" },
  "Local de Destino":        { kind: "text", key: "DischargePort" },
  "Armador":                 { kind: "text", key: "CustomsAgent" },
  "Demurrage":               { kind: "text", key: "Demurrage" },
  "Situação dos Câmbioss":   { kind: "text", key: "PaymentStatus" },
  "Moeda invoice":           { kind: "text", key: "Currency" },
  "Free Time":               { kind: "text", key: "FreeTime" },
  "Cotação Internacional":   { kind: "text", key: "InternationalQuote" },
  "Cotação Rodoviária":      { kind: "text", key: "RoadQuote" },
  "Seguro":                  { kind: "text", key: "Insurance" },
  "ICMS":                    { kind: "text", key: "Icms" },
  "Numerário":               { kind: "text", key: "CashAmount" },
  "Documentos":              { kind: "text", key: "Documents" },
  "Catálogo PU":             { kind: "text", key: "CatalogPu" },
  "Status LI":               { kind: "text", key: "LiStatus" },
  "Segmento":                { kind: "text", key: "Segment" },
  "Taxa Câmbio 1":           { kind: "text", key: "TaxaCambio1" },
  "Taxa Câmbio 2":           { kind: "text", key: "TaxaCambio2" },
  "Taxa Câmbio 3":           { kind: "text", key: "TaxaCambio3" },
  "Valor Parcela 1":         { kind: "text", key: "ValorPagamento1" },
  "Valor Parcela 2":         { kind: "text", key: "ValorPagamento2" },
  "Valor Parcela 3":         { kind: "text", key: "ValorPagamento3" },
  "Contrato 1º Pagamento":   { kind: "text", key: "ContratoCambio1" },
  "Contrato 2º pagamento":   { kind: "text", key: "ContratoCambio2" },
  "Data Câmbio 1":           { kind: "date", key: "DataCambio1" },
  "Data Câmbio 2":           { kind: "date", key: "DataCambio2" },
  "Data Câmbio 3":           { kind: "date", key: "DataCambio3" },
  "Data Pagamento 1":        { kind: "date", key: "DataPagamento1" },
  "Data Pagamento 2":        { kind: "date", key: "DataPagamento2" },
  "Data Pagamento 3":        { kind: "date", key: "DataPagamento3" },
};

// filtro (chave em ReportFilters.text/dates) -> label de coluna, pra auto-selecionar
// a coluna quando um relatório salvo tem filtro numa coluna não incluída em fields.
export const FILTER_KEY_TO_COLUMN: Record<string, string> = Object.fromEntries(
  Object.entries(COLUMN_FILTERS).map(([label, f]) => [f.key, label])
);
